"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M19 3H5.01L5 21l7-3 7 3zm-2 15-5-2.18L7 18V5h10z"
}), 'TurnedInNotSharp');